export const CUSTOMER_ACCESS_STATUS = {
  ACTIVE: "Active",
  SUSPENDED: "Suspended",
  INVITED: "Invited",
  REVOKED: "Revoked",
};

export const CUSTOMER_ACCESS_STATUS_RAW = {
  REVOKED: "Revoked",
  PENDING: "Pending",
  INACTIVE: "Inactive",
};

export const CUSTOMER_ACCESS_STATUS_OPTIONS = [
  { label: CUSTOMER_ACCESS_STATUS.ACTIVE, value: CUSTOMER_ACCESS_STATUS.ACTIVE },
  {
    label: CUSTOMER_ACCESS_STATUS.SUSPENDED,
    value: CUSTOMER_ACCESS_STATUS.SUSPENDED,
  },
  { label: CUSTOMER_ACCESS_STATUS.INVITED, value: CUSTOMER_ACCESS_STATUS.INVITED },
];

export const CUSTOMER_ACCESS_FILTER_OPTIONS = [
  { label: CUSTOMER_ACCESS_STATUS.ACTIVE, value: CUSTOMER_ACCESS_STATUS.ACTIVE },
  {
    label: CUSTOMER_ACCESS_STATUS.REVOKED,
    value: CUSTOMER_ACCESS_STATUS.REVOKED,
  },
  { label: CUSTOMER_ACCESS_STATUS.INVITED, value: CUSTOMER_ACCESS_STATUS.INVITED },
];

const ACCESS_STATUS_VALUES = new Set(
  [
    ...CUSTOMER_ACCESS_STATUS_OPTIONS.map((option) => option.value),
    CUSTOMER_ACCESS_STATUS.REVOKED,
  ]
);

export const normalizeCustomerAccessStatus = (raw) => {
  const s = String(raw ?? "").trim();
  if (!s) {
    return "";
  }
  if (
    s === CUSTOMER_ACCESS_STATUS_RAW.REVOKED ||
    s === CUSTOMER_ACCESS_STATUS.REVOKED
  ) {
    return CUSTOMER_ACCESS_STATUS.REVOKED;
  }
  if (ACCESS_STATUS_VALUES.has(s)) {
    return s;
  }
  return CUSTOMER_ACCESS_STATUS.SUSPENDED;
};

export const DEFAULT_CUSTOMER_ACCESS_STATUS_LABEL = "Customer access";

export const isCustomerAccessStatus = (raw, expectedStatus) =>
  normalizeCustomerAccessStatus(raw) === expectedStatus;

export const isRevokedCustomerAccessStatus = (raw) =>
  isCustomerAccessStatus(raw, CUSTOMER_ACCESS_STATUS.REVOKED);
